export default __webpack_public_path__ + "static/media/select1_arrow_inactive.0841c402.svg";